import React from 'react'
import { Provider } from 'react-redux'

import { default as Survey } from './components/survey.jsx'

import { default as store, loadResponses, loadScores } from './store.js'

import { load as loadSurvey }      from '../shared/ducks/survey.js'
import { loadWithReviewAndSubmit } from '../shared/ducks/coverage_types.js'
import { load as loadLookup }      from '../shared/ducks/lookups.js'


const RmgSurveyFrontendApp = (props) => {

    store.dispatch(loadSurvey(props))
    store.dispatch(loadWithReviewAndSubmit(props))
    store.dispatch(loadResponses(props.responses))
    store.dispatch(loadScores(props.scores))
    store.dispatch(loadLookup('tier', props.meta.tier))
    store.dispatch(loadLookup('saveAndExitLink', props.meta.saveAndExitLink))

    return (
      <Provider store={ store }>
        <Survey />
      </Provider>
    )
}
  

export default RmgSurveyFrontendApp
